<template>
  <transition name="modal-fade">
    <div class="modal fade show"
         style="display: block; padding-right: 15px;">
      <div :class="{'modal-lg': !small}"
           class="modal-dialog modal-centered">
        <div class="modal-content">
          <div class="modal-header">
            <slot :icon="imgicone"
                  name="header">
              <h4 id="exampleModalLabel"
                  class="modal-title">
                Modal title
              </h4>
            </slot>
            <a aria-label="Close"
               class="close"
               data-dismiss="modal"
               type="button"
               @click="close"><i class="fal fa-times fa-2x"/></a>
          </div>
          <div class="modal-body">
            <slot name="body">
              <h5>
                Body should be here!
              </h5>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-save-modal close pull-right saveBu"
                data-dismiss="modal"
                type="button"
                @click="close"
              >
                {{ $t('auth.cancel') }}
              </button>

              <button
                class="btn-save-modal btn btn-secondary pull-right"
                type="button"
                data-dismiss="modal"
                @click="saveModal"
              >
                {{ $t('auth.send') }}
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
	name: 't-modal',
	props: {
		imgicone: {
			type: String,
			default: null
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	mounted () {
		document.body.classList.add('modal-open')
	},
	destroyed () {
		document.body.classList.remove('modal-open')
	},
	methods: {
		close () {
			this.$emit('close')
		},
		saveModal () {
			this.$emit('saveModal')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/modal/index.vue